
function setup(holder) {
  const btn = holder.querySelector('.filter-dropdown__select');

  btn.addEventListener('click', toggleFilterOptions);
}

function toggleFilterOptions(event) {
  const btn = event.target;
  const holder = btn.parentElement;
  const filterOptions = holder.querySelector('.filter-dropdown__options');
  event.preventDefault();
  let isVisible = true;

  if (window.innerWidth >= 1000) {
    if (!filterOptions.parentElement.classList.contains('filter-dropdown--news') && window.innerWidth < 1300) {
      filterOptions.classList.remove('hidden');
      btn.classList.remove('collapsed');

      return;
    }

    if (window.innerWidth >= 1300) {
      filterOptions.classList.remove('hidden');
      btn.classList.remove('collapsed');

      return;
    }
  }

  if (filterOptions.classList.contains('hidden')) {
    filterOptions.classList.remove('hidden');
    filterOptions.classList.add('visible');
    isVisible = true;
  } else if (filterOptions.classList.contains('visible')) {
    filterOptions.classList.remove('visible');
    filterOptions.classList.add('hidden');
    isVisible = false;
  } else {
    filterOptions.classList.add('visible');
    isVisible = true;
  }

  if (isVisible) {
    btn.classList.add('collapsed');
  } else {
    btn.classList.remove('collapsed');
  }
}

function handleResize() {
  if (window.innerWidth >= 1000) {
    let selector = '.filter-dropdown:not(.filter-dropdown--news) .filter-dropdown__options';

    if (window.innerWidth >= 1300) {
      selector = '.filter-dropdown--news .filter-dropdown__options';
    }

    document.querySelectorAll(selector).forEach(item => {
      if (item.classList.contains('hidden')) {
        item.classList.remove('hidden');
      }
    });
  }
}

export default function () {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.filter-dropdown').forEach(holder => {
      setup(holder);
    });

    window.addEventListener('resize', handleResize)
  });
}
